import { useCallback, useMemo, useState } from 'react'
import { keyOf } from 'components/common/PinnedFilters/pinFilterUtils'

const EMPTY_OBJECT = {}
export function usePinnedFilters(initial = EMPTY_OBJECT) {
  const [activePinned, setActivePinned] = useState(() => initial || {})

  const toggle = useCallback((filter) => {
    setActivePinned((prev) => {
      const k = keyOf(filter.column, filter.value)
      const next = { ...prev }

      if (next[k]) {
        delete next[k]
      } else {
        next[k] = true
      }

      return next
    })
  }, [])

  const setMany = useCallback((next) => {
    setActivePinned(next || {})
  }, [])

  const update = useCallback((updates) => {
    setActivePinned((prev) => ({ ...prev, ...(updates || {}) }))
  }, [])

  const clear = useCallback(() => {
    setActivePinned({})
  }, [])

  const isActive = useCallback((filter) => {
    const k = keyOf(filter.column, filter.value)
    return !!activePinned[k]
  }, [activePinned])

  const keys = useMemo(() => Object.keys(activePinned), [activePinned])

  return useMemo(
    () => ({
      activePinned,
      setActivePinned,
      toggle,
      setMany,
      update,
      clear,
      isActive,
      keys,
    }),
    [activePinned, toggle, setMany, update, clear, isActive, keys],
  )
}